import { ChangeDetectorRef, Directive, ElementRef, input, OnDestroy, OnInit, Renderer2, signal, ViewContainerRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'input[irdClearableInput]',
})
export class ClearableInputDirective implements OnInit, OnDestroy {
  public formControl = input.required<FormControl>();

  private icon!: MatIcon;
  private subscription = signal<Subscription | undefined>(undefined);

  constructor(
    private renderer: Renderer2,
    private element: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private changeDetectionRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    const parentNode = this.element.nativeElement.parentNode;
    if (parentNode) {
      const componentInstance = this.viewContainerRef.createComponent(MatIcon);

      this.icon = componentInstance.instance;
      this.icon.fontIcon = 'close';

      const iconElement = this.icon._elementRef.nativeElement;

      iconElement.style.display = this.formControl().value ? 'block' : 'none';
      iconElement.style.cursor = 'pointer';

      this.handleFormControlChanges();

      iconElement.addEventListener('click', () => {
        this.clear();
      });

      this.renderer.appendChild(parentNode, iconElement);
      this.changeDetectionRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subscription()?.unsubscribe();
  }

  private handleFormControlChanges(): void {
    const subscription = this.formControl().valueChanges.subscribe((value) => {
      const iconElement = this.icon._elementRef.nativeElement;
      const currentDisplay = iconElement.style.display;

      if (!!value && currentDisplay === 'none') {
        iconElement.style.display = 'block';
      } else if (!value && currentDisplay === 'block') {
        iconElement.style.display = 'none';
      }
    });

    this.subscription.set(subscription);
  }

  private clear() {
    this.formControl().setValue(null);
  }
}
